import { Skeleton, TableBody, TableCell, TableRow } from "@mui/material";
import { FC } from "react";
import { TableSkeletonProps } from "../../interfaceTypes";

export const CaseTypeSkeleton: FC<TableSkeletonProps> = ({ noOfRows }) => (
  <TableBody>
    {new Array(noOfRows).fill(0).map((_, index) => (
      <TableRow key={`${index}-skeleton`}>
        <TableCell>
          <Skeleton variant="text" width={120} height={30} />
        </TableCell>
        <TableCell>
          <Skeleton variant="text" width={50} height={30} />
        </TableCell>
        <TableCell>
          <Skeleton variant="text" width={50} height={30} sx={{ margin: 'auto' }} />
        </TableCell>
      </TableRow>
    ))}
  </TableBody>
);